import { Contract } from "@ethersproject/contracts";
import { ACTIVE_NETWORK, NetworkDetails, RPC_URL } from "src/constants";
import Web3 from "web3";

export function sortAddress(add) {
  const sortAdd = `${add.slice(0, 6)}...${add.slice(add.length - 4)}`;
  return sortAdd;
}
export function sortapi(add) {
  const sortAdd = `${add.slice(0, 5)}...${add.slice(add.length - 6)}`;
  return sortAdd;
}
export function sortEmail(add) {
  const sortAdd = `${add.slice(0, 4)}xxx${add.slice(add.length - 4)}`;
  return sortAdd;
}
// export function sortAddress(add) {
//   if (add) {
//     const sortAdd = `${add?.slice(0, 6)}...${add?.slice(add.length - 4)}`;
//     return sortAdd;
//   }
//   return add;
// }
export function sortAddressSix(add) {
  const sortAdd = `${add?.slice(0, 6)}`;
  return sortAdd;
}
export function sortAddressOne(add) {
  const sortAdd = `${add?.slice(0, 1)}`;
  return sortAdd;
}

export function getSigner(library, account) {
  return library.getSigner(account).connectUnchecked();
}

export function getProviderOrSigner(library, account) {
  return account ? getSigner(library, account) : library;
}

export function getContract(address, ABI, library, account) {
  return new Contract(address, ABI, getProviderOrSigner(library, account));
}

export const getWeb3Provider = async () => {
  const httpProvider = new Web3.providers.HttpProvider(RPC_URL);
  return httpProvider;
};

export const getWeb3Obj = async () => {
  const httpProvider = new Web3.providers.HttpProvider(RPC_URL);
  const web3 = await new Web3(httpProvider);
  return web3;
};

export const getWeb3ContractObject = async (abi, contractAddress) => {
  const web3 = await getWeb3Obj();
  const contract = await new web3.eth.Contract(abi, contractAddress);
  return contract;
};

export const getWeb3ContractObject12 = async (
  abi,
  contractAddress,
  RPC_URL = RPC_URL
) => {
  const web3 = await getWeb3Obj(RPC_URL);
  const contract = await new web3.eth.Contract(abi, contractAddress);
  return contract;
};

export const getBalanceOf = async (abi, address, account) => {
  try {
    const contract = await getWeb3ContractObject(abi, address);
    const balanceOf = await contract.methods.balanceOf(account).call();
    return balanceOf.toString();
  } catch (error) {
    console.log("ERROR", error);

    return 0;
  }
};

export function isValidPassword(value) {
  var re = /^(?=.*\d)(?=.*[A-Z]).{8,14}$/;
  return re.test(value);
}

export function isValidNumber(value) {
  const re =
    /^(?:(?:\+|0{0,2})91(\s*|[\-])?|[0]?)?([6789]\d{2}([ -]?)\d{3}([ -]?)\d{4})$/;
  return re.test(value);
}
export function validPassword(value) {
  const re = /^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*#?&])[A-Za-z\d@$!%*#?&]{8,50}$/;
  return re.test(value);
}

export const calculateTimeLeft = (endDate) => {
  if (endDate) {
    let difference = endDate * 1000 - +new Date();
    let timeLeft = {};

    if (difference > 0) {
      timeLeft = {
        days: Math.floor(difference / (1000 * 60 * 60 * 24)),
        hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
        minutes: Math.floor((difference / 1000 / 60) % 60),
        seconds: Math.floor((difference / 1000) % 60),
      };
    }
    return timeLeft;
  } else {
    return false;
  }
};
